import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CompanyOverview from './components/CompanyOverview';
import OurServices from './components/OurServices';
import Locations from './components/Locations';
import ContactSection from './components/ContactSection';
import FAQ from './components/FAQ';
import LegalCertifications from './components/LegalCertifications';
import SeoJsonLd from './components/SeoJsonLd';

export default function Home() {
  return (
    <div className="font-sans">
      <SeoJsonLd />
      <Navbar />
      <main>
        <HeroSection />
        <OurServices />
        <Locations />
        <ContactSection />
        <FAQ />
        <CompanyOverview />
        <LegalCertifications />
      </main>
      <Footer />
    </div>
  );
}
